/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import { createAction } from 'redux-actions';
import { createAPIAction } from './api';
import { createTypesMap } from './types';

export const types = createTypesMap('tdm', [
  'setting',
  'getNetwork',
  'updateNodes',
  'updateTdmGateways',
]);

export const getNetwork = () => createAPIAction(
  types.getNetwork,
  {
    endpoint: '/tdmng/networks',
    method: 'GET',
  })();

export const setting = () => createAPIAction(
  types.setting,
  {
    endpoint: '/orgdocs/types',
    method: 'GET',
  })();

export const updateNodes = createAction(types.updateNodes, payload => payload);
export const updateTdmGateways = createAction(types.updateTdmGateways, payload => payload);

export default {
  setting,
  getNetwork,
  updateNodes,
  updateTdmGateways,
};




// WEBPACK FOOTER //
// ./src/redux/actions/tdm.js